import { checkIsErrorToolOutput } from "@repo/app-types/agents/errorToolOutput";
import { checkIsNoResultToolOutput } from "@repo/app-types/agents/noResultToolOutput";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

/** The run's tally is on the turn's test run row, so this row only names the step. */
export const RunVoiceAgentTestsTool: ToolComponent = ({ status, output }) => (
  <ChatToolBase status={status}>
    {status.type === "running"
      ? "Running test cases…"
      : checkIsErrorToolOutput(output) || checkIsNoResultToolOutput(output)
        ? "Could not run the test cases"
        : "Ran test cases"}
  </ChatToolBase>
);
